import { render, staticRenderFns } from "./TooltipBtn.vue?vue&type=template&id=af27aa30"
import script from "./TooltipBtn.vue?vue&type=script&lang=js"
export * from "./TooltipBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af27aa30')) {
      api.createRecord('af27aa30', component.options)
    } else {
      api.reload('af27aa30', component.options)
    }
    module.hot.accept("./TooltipBtn.vue?vue&type=template&id=af27aa30", function () {
      api.rerender('af27aa30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/extra/TooltipBtn.vue"
export default component.exports